export default __webpack_public_path__ + "img/cloudy-snow.b3cc78c.svg";